import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { BooleanInput, ConvertedComponentData, TextInput } from '../../types'
import { CmsConverterService, defaultBooleanInput, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class HeaderIntroTextConverter extends CmsConverterService<HeaderIntroTextData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const colorValue = formData?.st_header_intro_background?.value?.identifier ?? 'white'
    return {
      textIntro: formData.st_header_intro_text ?? defaultTextInput,
      textLarge: formData.st_header_intro_text_large ?? defaultTextInput,
      textSmall: formData.st_header_intro_text_small ?? defaultTextInput,
      fullWidth: formData?.st_header_intro_full_width ?? defaultBooleanInput,
      color: {
        value: colorValue,
        name: formData?.st_header_intro_background?.name ?? '',
        background: `bg-${colorValue}`
      }
    }
  }
}

export const HEADER_INTRO_TEXT_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, HeaderIntroTextData>>('HeaderIntroTextConverterToken')

export interface HeaderIntroTextData extends ConvertedComponentData {
  color: Color;
  fullWidth: BooleanInput;
  textIntro: TextInput;
  textLarge: TextInput;
  textSmall: TextInput;
}

interface Color {
  value: string;
  name: string;
  background: string;
}
